module.exports = __webpack_public_path__ + "img/bg_chess_01.655b0144.jpg";